import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { homeExploreCategory } from "../../store/actions/homeContentAction";
import { unescapeHTML } from "../common/Common";

const Experience = () => {
  const dispatch = useDispatch();
  const data_home = useSelector((state) => state.data_home_explore_category);
  const { loading } = data_home;

  useEffect(() => {
    dispatch(homeExploreCategory())
  }, [dispatch]);
  return (
    <>
      {!loading && data_home.data.isActive === 1 && (
        <div
          dangerouslySetInnerHTML={{
            __html: unescapeHTML(data_home.data.blockContent),
          }}
        ></div>
      )}
    </>
  );
};

export default Experience;
